import React from 'react';
import './about.scss';
import { translate } from "react-translate";
import Map from '../../map/map';

import ambassador from '../../../images/ambassador.jpg';

class About extends React.Component {

  render() {
    return (
      <div className="component about">
        <div id="location" style={{ position: 'relative', top: '-100px', height: 0 }}>&nbsp;</div>
        <div className="component block location">
          <div className="content">
            <div className="textC">
              <h4 className="title capsFont">{ this.props.t('location') }</h4>
              <p className="body bodyFont" style={{ textAlign: 'center' }}>{ this.props.t('address') }</p>
              <div><img className="location_image" src={ambassador} alt="hotel" /></div>
              <br />
              <Map title="hotel" height={200} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2978.0549363594214!2d44.77556941543602!3d41.71933338331379!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x404472d63c35b9a9%3A0xf4157611834d1322!2sHoliday%20Inn!5e0!3m2!1sen!2sge!4v1568880088934!5m2!1sen!2sge" />
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default translate('About')(About);
